import { render, staticRenderFns } from "./recordWidget.vue?vue&type=template&id=4777f9c3&"
import script from "./recordWidget.vue?vue&type=script&lang=ts&"
export * from "./recordWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports